import { authenticatedApi } from '../api';

export const API_CHANNEL_PATH = '/channel';

export const createDonation = (channelId, payload) => authenticatedApi.post(
	`${API_CHANNEL_PATH}/donation`,
	{
		...payload,
		channelId,
	},
);
